export default __webpack_public_path__ + "static/media/img4.60fa9324.png";